var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWedesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 122,
    viewBox: "0 0 140 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.561 100.959c0-.166.006-.331.011-.498.082-2.8.41-5.61.099-8.393-.055-.443-.137-.918-.449-1.235-.268-.268-.656-.375-1.027-.42-.826-.098-4.04 4.013-4.068 4.678-.038.732.082 1.46.208 2.182l1.394 8.352c.312 1.852.623 3.715 1.252 5.485.18.517.492 1.102 1.039 1.159.339.034.666-.165.869-.437.208-.273.306-.608.377-.941.18-.811.235-1.645.268-2.474.093-2.484-.028-4.972.027-7.458z",
    fill: "#E7C59B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.196 110.78s-.175-1.722 1.296-2.217c1.47-.495 2.405.69 2.405.69l-3.701 1.527z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.46 109.204c-.432.065-.875.407-1.28.588-1.334.601-2.564 1.32-3.87 1.978-.733.37-2.214.994-2.045 2.037.235 1.453 2.728.567 3.581.376 1.432-.319 2.936-.791 4.258-1.427 1.23-.59.864-1.396.684-2.152-.099-.408-.284-.821-.574-1.129-.24-.25-.492-.309-.755-.271z",
    fill: "#191919"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.064 97.766c-.038-.16-.082-.322-.12-.482-.673-2.72-1.115-5.514-2.17-8.11-.165-.414-.372-.848-.76-1.07-.328-.186-.733-.186-1.105-.128-.82.127-2.81 4.95-2.657 5.6.165.712.476 1.382.788 2.044 1.197 2.557 2.394 5.113 3.597 7.669.798 1.7 1.602 3.411 2.678 4.946.317.448.777.93 1.318.837.333-.057.596-.338.722-.655.12-.317.125-.667.109-1.006-.05-.83-.219-1.647-.416-2.455-.574-2.418-1.36-4.783-1.984-7.19z",
    fill: "#E7C59B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.462 108.128s-.634-1.61.65-2.483c1.285-.872 2.499.02 2.499.02l-3.149 2.463z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.185 105.734c-.404.179-.738.627-1.077.911-1.126.937-2.115 1.96-3.198 2.944-.606.553-1.864 1.552-1.421 2.512.618 1.336 2.783-.187 3.553-.602 1.29-.69 2.613-1.549 3.718-2.517 1.027-.9.459-1.578.076-2.257-.202-.367-.492-.714-.858-.932-.295-.176-.558-.166-.793-.059zM79.434 77.796s-1.236 2.551.617 7.128c1.848 4.578 7.266 15.136 8.146 14.984.885-.151 8.834-3.84 9.096-4.72.268-.88-4.362-15.457-4.362-15.457s-3.8-6.6-4.067-6.6c-.263 0-9.43 4.665-9.43 4.665z",
    fill: "#191919"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.27 122h3.173V35.861H29.27V122z",
    fill: "#CBCBCB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.018 122H18.686a1.321 1.321 0 1 1 0-2.641h24.332a1.321 1.321 0 1 1 0 2.641zM123.164 122h3.171V53.816h-3.171V122z",
    fill: "#CBCBCB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.917 122h-24.332a1.32 1.32 0 1 1 0-2.641h24.332c.727 0 1.323.591 1.323 1.32 0 .73-.596 1.321-1.323 1.321zM7.626 17.293h91.466l36.545 41.817h-94.73L7.625 17.293z",
    fill: "#CBCBCB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.857 22.806 51.02 52.93h65.351L94.308 22.806h-66.45z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m78.815 36.03-7.32-9.188H54.308v-.546h17.455l7.478 9.395-.426.34z",
    fill: "#CBCBCB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.522 49.902a.28.28 0 0 1-.219-.103L56.29 24.45a.272.272 0 0 1 .05-.383.272.272 0 0 1 .382.046l20.013 25.35a.276.276 0 0 1-.043.382.282.282 0 0 1-.17.058zM68.673 47.527H57.22l-.082-.102L44.21 31.49h9.392v.546h-8.245l12.127 14.946h11.19v.546z",
    fill: "#CBCBCB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9 17.293 76.044 59.11h6.118L47.336 17.293H40.9z",
    fill: "#666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.454 41.189a.276.276 0 0 1-.218-.11L65.29 25.18a.27.27 0 0 1 .055-.38c.12-.09.29-.067.382.054l11.945 15.9a.27.27 0 0 1-.055.381.276.276 0 0 1-.164.055z",
    fill: "#CBCBCB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.046 14.299H1.473c-.814 0-1.473.658-1.473 1.47v.826c0 .452.155.89.438 1.242l32.637 40.525c.381.472.956.747 1.564.747h6.268V57.2a2.6 2.6 0 0 0-.576-1.63L7.685 15.081a2.106 2.106 0 0 0-1.64-.783zM105.374 14.299h-4.587c-.934 0-1.694.757-1.694 1.69v1.304l33.286 41.327c.246.31.623.49 1.022.49h5.708a.89.89 0 0 0 .891-.89v-1.369c0-.368-.126-.725-.356-1.01l-33.013-40.942c-.306-.38-.771-.6-1.257-.6z",
    fill: "#666"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.343 32.847c-.312-.815-1.066-1.326-1.738-1.828-1.285-.964-2.488-2.025-3.758-3.009.009-.072.022-.145.024-.215.006-.015.016-.025.02-.042.438-1.554-2.476-5.241-4.056-3.772-.745.693-.348 2.165.024 2.95.292.617.918 1.864 1.744 1.871.433.707 1.21 1.445 1.53 1.833.634.767 1.301 1.494 1.951 2.248.503.587.93 1.279 1.624 1.653.235.128.454-.124.35-.35-.131-.29-.563-.597-.574-.927-.027-.663.716-.057 1.006-.242.033-.019.197-.279.164-.284.12.02.23.017.339-.017.355.279.732.531 1.191.405.11-.03.203-.16.159-.274z",
    fill: "#E7C59B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.086 45.547h15.673V45H73.086v.546zM85.16 122c-.776 0-1.41-.631-1.41-1.409V80.896h2.82v39.695c0 .778-.628 1.409-1.41 1.409zM107.822 122c.776 0 1.41-.631 1.41-1.409V80.896h-2.821v39.695c0 .778.629 1.409 1.411 1.409z",
    fill: "#CBCBCB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.23 81.668H83.75v-1.999a4.87 4.87 0 0 1 4.876-4.867h15.728a4.87 4.87 0 0 1 4.876 4.867v1.999z",
    fill: "#666"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.156 112.275h21.867v-1.936H85.156v1.936z",
    fill: "#CBCBCB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.666 22.665c-.038.808-.148 1.679-.612 2.239-.662.787-1.985.697-2.925.655-1.257-.059-2.657-.502-3.624-1.315-.476-.401-.87-.919-.957-1.552-.033-.249-.148-1.638.35-1.611-.05-.006-.306-.555-.536-1.093-.208-.465-.399-.925-.437-1.02-.017-.053-.038-.106-.06-.163v-.006c-.05.021-.099.037-.142.053a4.666 4.666 0 0 1-1.45.211c-1.502-.058-2.568-1.13-3.328-2.588-.006-.005-.006-.01-.011-.015a6.246 6.246 0 0 1-.23-.46c-.01-.015-.016-.037-.027-.053-.727-1.59-1.17-3.506-1.476-5.064-.06-.302-.115-.581-.164-.85-.06-.322-.12-.618-.17-.877-.164-.819-.18-1.447.541-1.98 1.881-1.379 3.844-1.443 6.047-1.178 2.47.29 2.438 3.02 4.1 4.215 1.831 1.32 1.979 3.094 2.826 4.969.514 1.146.951 2.329 1.383 3.506.312.84.612 2.604 1.241 3.232.219.222-.044.724-.339.745z",
    fill: "#E7C59B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.171 6.776v-.035c-.06-.945.268-1.66-.044-2.619-.284-.86-.83-1.62-1.486-2.238C96.356.667 94.475-.188 92.677.036c-1.378.171-2.744-.055-4.09.281-.808.203-1.623.463-2.273 1-.656.534-1.1 1.281-1.76 1.809-1.061.843-1.722 2.135-1.668 3.512-.076.608.115 1.352.377 1.711.345.454.973.666 1.476.893.41.19.864.21 1.296.132.17.554.497 1.066 1.011 1.574.536.527 1.143.919 1.498 1.584.186.348.3.718.508 1.056a3.728 3.728 0 0 0 1.482 1.39c.623.337 1.34.464 1.962.791.804.423 1.323.956 2.27.956 1.049 0 2.17-.108 3.06-.708.389-.264.695-.691.842-1.13.246-.727-.087-1.376.252-2.08.404-.853.803-1.616.83-2.58a8.197 8.197 0 0 0-.393-2.719c-.076-.24-.164-.48-.186-.732z",
    fill: "#191919"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.234 11.129s.449-.887 1.274-.469c.826.418.755 3.24.755 3.24l-1.121.105-.908-2.876z",
    fill: "#E7C59B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.677 19.697c-.104.09-.203.19-.312.29-.208-.464-.4-.924-.438-1.02-.016-.051-.038-.104-.06-.162.23-.128.443-.28.673-.429.153-.1.503-.348.678-.168a.35.35 0 0 1 .082.195c.076.528-.263.956-.623 1.294z",
    fill: "#DBB17E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.764 21.541s-2.476-2.187-2.509-2.364c-.033-.177-.311-2.498-1.17-3.224-.863-.726-2.312-1.376-4.056.098-.656.553-1.782 2.074-.394 2.082 1.389.009 1.881-.057 2.215.174.328.23.262.792.563 1.254.295.462.896.76.896.76s1.848 2.936 1.848 3.035c0 .1 2.607-1.815 2.607-1.815z",
    fill: "#E7C59B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.238 24.017c-.35-.088-3.586-4.317-7.549-3.392-3.969.924-5.423 3.656-4.964 6.098.208 1.081 2.848 4.621 2.848 4.621s5.893-4.334 6.2-4.466c.3-.133 3.465-2.861 3.465-2.861z",
    fill: "#EB5976"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.597 13.107a.627.627 0 0 0-.831.307l-3.838 8.302-.12 1.228c-.022.223.251.348.404.186l.859-.889 3.832-8.302a.623.623 0 0 0-.306-.832z",
    fill: "#371005"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.695 56.76s4.04 11.758.53 16.194c-3.504 4.437-8.375 2.993-16.662 3.257-8.287.264-19.483 4.665-20.544 5.897-1.055 1.233-1.055 16.46-1.672 17.251-.618.792-7.97.932-8.856.316-.88-.616-3.067-17.146-.667-23.112 3.088-7.657 18.69-11.794 22.129-13.026 3.438-1.233 4.674-4.665 4.674-4.665l21.068-2.112z",
    fill: "#191919"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.135 58.923c-.148-1.116-.35-2.345-.842-3.377a38.16 38.16 0 0 1-.208-1.347c-.098-.699-.18-1.4-.257-2.1-.672-5.812-1.241-11.649-2.17-17.425.662-1.61.509-3.274.41-5.043-.109-2.044-.465-4.056-1.869-5.598-1.269-1.38-2.493-2.704-4.281-3.423-1.891-.752-3.427-1.352-5.483-1.418-2.214-.07-4.444.106-6.587.69-3.16.865-6.276 2.35-9.217 3.775-1.569.761-3.05 1.77-4.483 2.752-1.667 1.151-3.564 1.595-5.466 2.18-1.793.553-3.351.981-4.991 1.918-1.793 1.04-4.139 1.437-6.117.73-1.76-.635-3.28-1.717-5.073-2.24-2.69-.784-4.401-1.836-6.224.125-.347.374-2.027 1.893-.837 4.268.853 1.704 1.763 2.47 3.485 4.812 1.012 1.382 3.182 2.538 4.756 3.198 3.335 1.395 4.357 2.485 8.064 1.94a83.72 83.72 0 0 0 5.822-1.072c2.033-.452 7.401-1.767 8.867-2.132.224.502.584.993.792 1.473.443 1.014.558 2.038.81 3.095.393 1.626 1.218 3.093 1.656 4.708.459 1.706.688 3.462.918 5.21.219 1.621.585 3.352.476 4.976-.148 2.224.497 2.821 2.449 4.444.924.767 2.192.997 3.29 1.405 1.673.62 3.16 1.546 4.44 2.795 1.05 1.025 2.142 2.291 3.487 2.933 1.225.582 2.608 1.286 3.996.987 1.088-.232 2.16-.673 3.067-1.316.858-.61 1.372-1.55 2.165-2.242a42.535 42.535 0 0 1 2.11-1.727c.82-.635 1.798-1.33 2.29-2.272.864-1.67 1.323-3.84.755-5.682z",
    fill: "#EB5976"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.53 44.622H51.523a.273.273 0 1 1 0-.546H61.53c.154 0 .274.122.274.273 0 .15-.12.273-.273.273z",
    fill: "#CBCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWedesign);
export default __webpack_public_path__ + "static/media/wedesign.16242f2e74842d2515461d691c5b96c2.svg";
export { ForwardRef as ReactComponent };